var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widthFull", attrs: { id: "site-nav" } }, [
    _c(
      "nav",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.menuOFF,
            expression: "!menuOFF"
          }
        ],
        staticClass: "navbar navbar-light navbar-expand-lg fixed-top",
        class: { navGreen: _vm.scroll > 30 || _vm.$route.path != "/" },
        staticStyle: { "z-index": "11" }
      },
      [
        _c("div", { staticClass: "container widthFull" }, [
          _c(
            "div",
            { staticClass: "navbar-header" },
            [
              _c(
                "router-link",
                {
                  directives: [
                    {
                      name: "scroll-to",
                      rawName: "v-scroll-to",
                      value: ".main",
                      expression: "'.main'"
                    }
                  ],
                  staticClass:
                    "navbar-brand router-link-exact-active router-link-active",
                  attrs: { to: "/" }
                },
                [
                  _c("img", {
                    ref: "mainNavLogo",
                    staticClass: "img-fluid logo ml-3",
                    attrs: {
                      src: require("../../assets/images/logo.png"),
                      alt: ""
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _vm._m(0)
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "collapse navbar-collapse flex-column ml-0 pl-3",
              attrs: { id: "navbarCollapse" }
            },
            [
              _c("ul", { staticClass: "navbar-nav ml-auto mb-lg-0 mb-5" }, [
                !_vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            directives: [
                              {
                                name: "scroll-to",
                                rawName: "v-scroll-to",
                                value: ".main",
                                expression: "'.main'"
                              }
                            ],
                            staticClass: "nav-link",
                            attrs: {
                              to: "/",
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Home")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _c("li", { staticClass: "nav-item dropdown mr-0 pd-0" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "nav-link dropdown-toggle menuItem mr-0 pd-0",
                          attrs: {
                            href: "#",
                            id: "navbardrop",
                            "data-toggle": "dropdown"
                          }
                        },
                        [_vm._v("\n                Home\n              ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-menu bgDrop",
                          attrs: {
                            "data-toggle": "collapse ",
                            "data-target": ".navbar-collapse.show"
                          }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              directives: [
                                {
                                  name: "scroll-to",
                                  rawName: "v-scroll-to",
                                  value: ".main",
                                  expression: "'.main'"
                                }
                              ],
                              staticClass: "dropdown-item menuItem",
                              attrs: {
                                to: "/",
                                "data-toggle": "collapse",
                                "data-target": ".navbar-collapse.show"
                              }
                            },
                            [
                              _c("span", { staticClass: "menuItem ipadMenu" }, [
                                _vm._v("HOME")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              directives: [
                                {
                                  name: "scroll-to",
                                  rawName: "v-scroll-to",
                                  value: { el: "#howplay", offset: -45 },
                                  expression: "{ el: '#howplay', offset: -45 }"
                                }
                              ],
                              staticClass: "dropdown-item menuItem",
                              attrs: {
                                to: "/",
                                "data-toggle": "collapse",
                                "data-target": ".navbar-collapse.show"
                              }
                            },
                            [
                              _c("span", { staticClass: "menuItem ipadMenu" }, [
                                _vm._v("Come funziona")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              directives: [
                                {
                                  name: "scroll-to",
                                  rawName: "v-scroll-to",
                                  value: { el: "#services", offset: -45 },
                                  expression: "{ el: '#services', offset: -45 }"
                                }
                              ],
                              staticClass: "dropdown-item menuItem",
                              attrs: {
                                to: { path: "/" },
                                "data-toggle": "collapse",
                                "data-target": ".navbar-collapse.show"
                              }
                            },
                            [
                              _c("span", { staticClass: "menuItem ipadMenu" }, [
                                _vm._v("Servizi")
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ]),
                _vm._v(" "),
                !_vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            directives: [
                              {
                                name: "scroll-to",
                                rawName: "v-scroll-to",
                                value: { el: "#howplay", offset: -45 },
                                expression: "{ el: '#howplay', offset: -45 }"
                              }
                            ],
                            staticClass: "nav-link",
                            attrs: {
                              to: "/",
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Come funziona")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            directives: [
                              {
                                name: "scroll-to",
                                rawName: "v-scroll-to",
                                value: { el: "#services", offset: -45 },
                                expression: "{ el: '#services', offset: -45 }"
                              }
                            ],
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Servizi")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProfileLoaded && _vm.hasPrev
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/calcolatore" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Crea Nuovo Preventivo")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProfileLoaded && _vm.hasPrev
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/offerte" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Gestione Preventivi")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProfileLoaded && !_vm.hasPrev
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/calcolatore" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Crea Pratica")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/pratiche" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Gestione Pratiche")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProfileLoaded
                  ? _c("li", { staticClass: "nav-item dropdown mr-0 pd-0" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "nav-link dropdown-toggle menuItem mr-0 pd-0",
                          attrs: {
                            href: "#",
                            id: "navbardrop",
                            "data-toggle": "dropdown"
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "pointer mr-0 pd-0",
                            attrs: { icon: "user", size: "1x" }
                          }),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.getProfile.name) +
                              " " +
                              _vm._s(_vm.getProfile.lastname) +
                              "\n              "
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-menu bgDrop",
                          attrs: {
                            "data-toggle": "collapse ",
                            "data-target": ".navbar-collapse.show"
                          }
                        },
                        [
                          !_vm.adminIs
                            ? _c(
                                "router-link",
                                {
                                  directives: [
                                    {
                                      name: "scroll-to",
                                      rawName: "v-scroll-to",
                                      value: ".main",
                                      expression: "'.main'"
                                    }
                                  ],
                                  staticClass: "dropdown-item menuItem",
                                  attrs: {
                                    to: "/account",
                                    "data-toggle": "collapse",
                                    "data-target": ".navbar-collapse.show"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "menuItem ipadMenu" },
                                    [_vm._v("Modifica Profilo")]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "dropdown-item pointer menuItem black",
                              on: { click: _vm.logout }
                            },
                            [
                              _c("span", { staticClass: "menuItem ipadMenu" }, [
                                _vm._v("Esci")
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          { staticClass: "nav-link", attrs: { to: "/login" } },
                          [
                            _c("span", { staticClass: "menuItem" }, [
                              _vm._v("Accedi")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "notificationContent",
              class: { notificationC: _vm.showNotification }
            },
            [
              _c(
                "div",
                { staticClass: "container relative pb-5 maxNotification" },
                [
                  _c(
                    "div",
                    { staticClass: "row justify-content-center widthFull" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-8 pl-5 pb-2 pt-4 pb-4 reverse" },
                        [
                          _vm._l(_vm.notifications, function(item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass:
                                  "row justify-content-center widthFull"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "col-md-11 pl-5 mb-2",
                                    class: {
                                      errorBg: item.type == "ERROR",
                                      successBg: item.type == "SUCCESS"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(parseInt(index) + 1) +
                                        ") "
                                    ),
                                    _c("span", {
                                      domProps: { innerHTML: _vm._s(item.text) }
                                    })
                                  ]
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm.countNotification == 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "row justify-content-center widthFull"
                                },
                                [_vm._m(2)]
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }),
    _vm._v(" "),
    _vm.vw > 767
      ? _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.menuOFF,
                expression: "!menuOFF"
              },
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.outside3,
                expression: "outside3"
              }
            ],
            staticClass: "sidetab2"
          },
          [
            _c(
              "div",
              { staticClass: "label", on: { click: _vm.toggleNotification } },
              [
                _vm.vw < 533
                  ? _c("img", {
                      staticClass: "img-fluid contactImg",
                      attrs: {
                        src: require("../../assets/images/contact2.png")
                      }
                    })
                  : _c("span", [
                      _c("img", {
                        staticClass: "leftIm2",
                        attrs: {
                          src: require("../../assets/images/notifications.png")
                        }
                      }),
                      _vm._v("\n          Notifiche\n          "),
                      _vm.countNotification
                        ? _c("span", [_vm._v(_vm._s(_vm.countNotification))])
                        : _vm._e()
                    ])
              ]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.acceptCookies
      ? _c("div", { staticClass: "container-fluid fixed cookieBaner" }, [
          _c("div", { staticClass: "row justify-content-center widthFull" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-sm-10 col-md-9 col-lg-6 pt-sm-0 pt-md-3"
              },
              [
                _c("span", { staticClass: "cookieText" }, [
                  _vm._v(
                    "\n            Utilizziamo i cookie al fine di personalizzare e migliorare la tua\n            esperienza sul nostro sito. Visita la nostra\n            "
                  ),
                  _c(
                    "a",
                    {
                      staticStyle: {
                        color: "#f39324 !important",
                        "text-decoration": "underline"
                      },
                      attrs: { target: "_blank", href: _vm.cookiePolicy }
                    },
                    [_vm._v("informativa")]
                  ),
                  _vm._v(
                    "\n            per acquisire maggiori informazioni. Utilizzando il nostro sito\n            accetti l'utilizzo dei cookie da parte nostra.\n          "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "\n            col-12 col-sm-2\n            center\n            col-md-2 col-lg-2\n            mt-sm-5\n            pt-3 pt-md-2\n            mt-md-3\n          "
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-primary btn-lg yellowBtn mb-5 pr-3 pl-3",
                    on: { click: _vm.doAcceptCookies }
                  },
                  [_vm._v("\n            OK\n          ")]
                )
              ]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass:
          "\n              navbar-toggler navbar-toggler-right\n              align-self-center\n              navbar-toggle\n              collapsed\n            ",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#navbarCollapse",
          "aria-expanded": "false"
        }
      },
      [
        _c("span", { staticClass: "sr-only" }, [_vm._v("Toggle navigation")]),
        _vm._v(" "),
        _c("span", { staticClass: "icon-bar top-bar" }),
        _vm._v(" "),
        _c("span", { staticClass: "icon-bar middle-bar" }),
        _vm._v(" "),
        _c("span", { staticClass: "icon-bar bottom-bar" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 pl-5 pb-2" }, [
      _c("h2", { staticClass: "black widthFull pb-0 mb-1" }, [
        _c("b", { staticClass: "widthFull" }, [_vm._v("Notifiche")])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "widthFull" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 center pl-5" }, [
      _c("h5", {}, [_c("b", [_vm._v("Non hai nessuna notifica")])])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1eacecb2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eacecb2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/index.vue
// module id = null
// module chunks = 